import React, { useState } from 'react';
import { Button, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const BillGenerator = () => {
  const [billNumber, setBillNumber] = useState('');
  const [billDate, setBillDate] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [items, setItems] = useState([{ description: '', quantity: 1, price: 0 }]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [format, setFormat] = useState('Classic');

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    setItems(newItems);
    calculateTotal();
  };

  const calculateTotal = () => {
    const total = items.reduce((sum, item) => sum + item.quantity * item.price, 0);
    setTotalAmount(total);
  };

  const handleAddItem = () => {
    setItems([...items, { description: '', quantity: 1, price: 0 }]);
  };

  const getDocDefinition = () => {
    const baseContent = [
      { text: `Bill Number: ${billNumber}`, style: 'header' },
      { text: `Date: ${billDate}`, style: 'subheader' },
      { text: `Customer Name: ${customerName}`, style: 'subheader' },
      { text: 'Items:', style: 'subheader' },
      {
        table: {
          body: [
            ['Description', 'Quantity', 'Price'],
            ...items.map(item => [item.description, item.quantity, item.price]),
            [{ text: 'Total', colSpan: 2 }, {}, totalAmount],
          ],
        },
      },
    ];

    const styles = {
      header: { fontSize: 18, bold: true },
      subheader: { fontSize: 14, margin: [0, 10, 0, 5] },
    };

    switch (format) {
      case 'Table':
        return { content: baseContent, styles: { ...styles, header: { fontSize: 18, bold: true, color: '#0000FF' } } };
      case 'Modern':
        return { content: baseContent, styles: { ...styles, subheader: { fontSize: 14, margin: [0, 15, 0, 10], color: '#FF5733' } } };
      case 'Minimal':
        return { content: baseContent, styles: { ...styles, header: { fontSize: 16, bold: true, color: '#2ECC71' } } };
      case 'Professional':
        return { content: baseContent, styles: { ...styles, header: { fontSize: 20, bold: true, color: '#34495E' } } };
      case 'Detailed':
        return { content: baseContent, styles: { ...styles, subheader: { fontSize: 16, margin: [0, 20, 0, 10], color: '#8E44AD' } } };
      case 'Simple':
        return { content: baseContent, styles: { ...styles, header: { fontSize: 16, bold: true, color: '#1ABC9C' } } };
      case 'Elegant':
        return { content: baseContent, styles: { ...styles, header: { fontSize: 18, bold: true, color: '#E74C3C' }, subheader: { fontSize: 14, margin: [0, 15, 0, 10], color: '#E74C3C' } } };
      default:
        return { content: baseContent, styles };
    }
  };

  const handleDownload = () => {
    const docDefinition = getDocDefinition();
    pdfMake.createPdf(docDefinition).download(`${billNumber}.pdf`);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Generate Bill</h1>
      <TextField
        label="Bill Number"
        value={billNumber}
        onChange={(e) => setBillNumber(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Date"
        value={billDate}
        onChange={(e) => setBillDate(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Customer Name"
        value={customerName}
        onChange={(e) => setCustomerName(e.target.value)}
        fullWidth
        margin="normal"
      />
      {items.map((item, index) => (
        <div key={index}>
          <TextField
            label="Description"
            value={item.description}
            onChange={(e) => handleItemChange(index, 'description', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Quantity"
            type="number"
            value={item.quantity}
            onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Price"
            type="number"
            value={item.price}
            onChange={(e) => handleItemChange(index, 'price', e.target.value)}
            fullWidth
            margin="normal"
          />
        </div>
      ))}
      <Button variant="contained" color="primary" onClick={handleAddItem}>
        Add Item
      </Button>
      <FormControl fullWidth margin="normal">
        <InputLabel>Format</InputLabel>
        <Select value={format} onChange={(e) => setFormat(e.target.value)}>
          {['Classic', 'Table', 'Modern', 'Minimal', 'Professional', 'Detailed', 'Simple', 'Elegant'].map(fmt => (
            <MenuItem value={fmt} key={fmt}>{fmt}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        startIcon={<SaveIcon />}
        onClick={handleDownload}
      >
        Generate Bill
      </Button>
    </div>
  );
};

export default BillGenerator;
